import { AxiosResponse } from "axios";
import { ActionTree } from "vuex";
import { ISaleOrderState } from "./state";
import { SET_SALE_ORDERS } from "./mutations-types";
import { apiClient } from "@/services";
import { ISaleOrder } from "@/models";

export const actions: ActionTree<ISaleOrderState, number> = {

    async fetchSaleOrders(context): Promise<AxiosResponse<ISaleOrder[]>> {
        const response = await apiClient.get<ISaleOrder[]>(`/saleorders`);
        context.commit(SET_SALE_ORDERS, response.data);

        return response;
    },

    async startSaleOrder(context, saleOrderId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/saleorders/${saleOrderId}/start`);
        return response;
    },

    async endSaleOrder(context, saleOrderId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/saleorders/${saleOrderId}/end`);
        return response;
    },

    async commentSaleOrderComponent(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/saleordercomponents/${data.saleOrderComponentId}/comment/${data.comment}`);
        return response;
    },

};
